import React, { createContext, useContext, useState } from 'react';

type FilterContextType = {
  isCollapsed: boolean;
  toggle: () => void;
};

const FilterContext = createContext<FilterContextType | undefined>( undefined );

export const FilterProvider: React.FC<{ children: React.ReactNode }> = ( { children } ) => {
  const [ isCollapsed, setIsCollapsed ] = useState( true );

  return (
    <FilterContext.Provider value={{ isCollapsed, toggle: () => {return setIsCollapsed( p => {return !p;} );} }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const ctx = useContext( FilterContext );
  if ( !ctx ) {
    throw new Error( 'useFilter must be used within FilterProvider' );
  }
  return ctx;
};
